import { AppUrlPath } from "@/lib/AppUrlPath";
import { cn } from "@repo/shared/utils";
import { useUserStore } from "@/stores/userStore";
import { Link } from "react-router-dom";
import { useGetAgendaModule } from "@/hooks/queryHooks/agendaModuleHooks";

export const AgendaModuleSummaryItem = ({
  tenantId,
  agendaModuleId,
}: {
  tenantId: string;
  agendaModuleId: string;
}) => {
  const activeTeam = useUserStore((s) => s.activeTeam);
  const { data: agendaModule } = useGetAgendaModule(tenantId, agendaModuleId);
  const path =
    agendaModuleId && activeTeam !== "org"
      ? new AppUrlPath(tenantId).getAgendaModulePath(agendaModuleId)
      : "";

  return (
    <Link
      className={cn(
        "block hover:underline",
        path === "." && "pointer-events-none"
      )}
      to={path}
    >{`${!agendaModuleId ? "Unknown" : agendaModule?.name ?? "..."}`}</Link>
  );
};
